import React from 'react';
// Material UI core
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import RateWidget from 'components/BikePage/RateWidget';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    padding: 0,
  },

  mainTitle: {
    fontSize: theme.typography.pxToRem(36),
    fontWeight: 'bold',
    color: theme.palette.grey[900],
    marginBottom: theme.spacing(1),
    padding: 0,
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.pxToRem(20),
      maringBottom: theme.spacing(2),
    },
  },
  subTitle: {
    fontSize: theme.typography.pxToRem(20),
    fontWeight: '300',
    color: theme.palette.grey[600],
    [theme.breakpoints.down('sm')]: {
      fontSize: theme.typography.pxToRem(14),
    },
  },
  rateContainer: {
    margin: `0 ${theme.typography.pxToRem(12)}`,
  },
  whiteTitle: {
    color: theme.palette.common.white,
  },
}));

const HeaderTitle = (props) => {
  const { isModalTitle, data } = props;
  const classes = useStyles();

  const titleClasses = clsx(classes.mainTitle);
  const subTitleClasses = clsx(classes.subTitle);

  return (
    <Box className={classes.root}>
      <Typography classes={{ root: titleClasses }} variant="h1">
        {data.title}
      </Typography>
      <Box
        display="flex"
        flexDirection="row"
        alignItems="center"
        className={classes.subTitle}
      >
        <Typography className={subTitleClasses} variant="subtitle1">
          {data.location}
        </Typography>
        <div className={classes.rateContainer}>
          {data.rate && data.rate != 'null' && (
            <RateWidget type="rate" value={data.rate} />
          )}
        </div>
        {!isModalTitle
          && data.trips_count != 'null'
          && data.trips_count > 0 && (
            <RateWidget value={data.trips_count} text="trips" />
        )}
      </Box>
    </Box>
  );
};

export default HeaderTitle;
